module.exports = __webpack_public_path__ + "static/media/srt.9fb7213b.jpg";